module.exports = __webpack_public_path__ + "static/media/marketing-slow-angel-mb.34475280.png";